import { render } from "./VentasViews.vue?vue&type=template&id=6efb16c2&scoped=true"
import script from "./VentasViews.vue?vue&type=script&lang=js"
export * from "./VentasViews.vue?vue&type=script&lang=js"

import "./VentasViews.vue?vue&type=style&index=0&id=6efb16c2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6efb16c2"]])

export default __exports__